module.exports = __webpack_public_path__ + "img/case3.0ca3a271.jpg";